import Promise from 'bluebird';
import _ from 'underscore';
import {
  constants,
  ImageExperienceImage,
} from '@bingads-webui-campaign-react/image-experience';
import {
  newVideoFromGridObject,
  newVideoFromMTObject,
} from '@bingads-webui-campaign-react/image-experience-video-part';
import { getAllImagesInfoFromMTAssets, getImageProps } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

/**
 * Get videos with original thumbnail url and custom thumbnail record.
 * @param {object} odata OData object for sending request
 * @param {string} baseURL URL with customer ID and account ID
 * @param {Array} videos Array of videos from Ad
 * @returns {Promise} resolve list of videos and custom thumbnail record.
 */
export const getVideosAndThumbnailsFromMTAssets = (
  odata,
  baseURL,
  videos
) => {
  const thumbnailRecord = {};
  const thumbnailAssets = _.pluck(videos, 'Asset').map(asset => ({ Asset: asset.CustomThumbnailAsset || {} }));

  const options = {
    mTAssetArrays: thumbnailAssets,
    baseURL,
    odata,
  };

  return getAllImagesInfoFromMTAssets(options)
    .then(imageToUrlMap => Promise.all(constants.videoTypesWithOrder.map((videoType) => {
      const videoWrapper = videos.find(v => v.Asset.SubType === videoType);
      const video = videoWrapper.Asset;
      let thumbnail;
      const customThumbnailAsset = video && video.CustomThumbnailAsset;
      if (customThumbnailAsset) {
        const imageProps = getImageProps(customThumbnailAsset, imageToUrlMap, true);
        imageProps.type = customThumbnailAsset.SubType;
        thumbnail = new ImageExperienceImage(imageProps);
      }

      // MT overrides ThumbnailUrl so we need to restore it by calling OData
      if (thumbnail) {
        thumbnailRecord[thumbnail.Type] = thumbnail;
        const url = `${baseURL}Videos/${video.Id}`;
        return odata.get(url)
          .then(asset => newVideoFromMTObject({ ...asset, SubType: videoType }));
      }
      return Promise.resolve(newVideoFromGridObject(video));
    }))
      .then(videoList => ({ videoList, thumbnailRecord })));
};
